// Patch affirm.ui.refresh with a no-op fallback to prevent errors,
// retrying up to 20 times if affirm or its UI isn't loaded yet.
(function patchAffirm() {
  let retries = 0;
  function safePatch() {
    if (window.affirm?.ui?.refresh) return;
    if (window.affirm?.ui) {
      window.affirm.ui.refresh = function () {
        console.warn("[Patch] affirm.ui.refresh fallback called");
        return Promise.resolve(); // prevent unhandledrejection
      };
      return;
    }
    if (retries++ < 20) {
      setTimeout(safePatch, 100);
    } else {
      console.warn("[Patch] affirm.ui not available after 20 retries");
    }
  }
  safePatch();
})();

window.addEventListener(
  "touchstart",
  function () {
    try {
      const test = window.parent.document;
    } catch (e) {
      console.warn("Blocked cross-origin frame access:", e);
    }
  },
  true,
);

// Wrap in DOMContentLoaded to ensure page is ready
document.addEventListener("DOMContentLoaded", function () {
  // Handle unhandled Promise rejections
  window.addEventListener("unhandledrejection", function (event) {
    console.error("Unhandled promise rejection:", event.reason);
    event.preventDefault(); // optional: prevent escalation
  });

  // Handle global JS errors
  window.onerror = function (message, source, lineno, colno, error) {
    console.error("Global JS error:", { message, source, lineno, colno, error });
  };
});

// Patch to safely prevent "window.UET is not a constructor" errors
if (typeof window.UET !== "function") {
  window.UET = undefined; // Prevent TypeError if Bing UET isn't loaded yet
}
if (typeof window.uetq === "undefined") {
  window.uetq = []; // Initialize uetq queue to prevent push errors
}

// Safe Qualtrics loader with error handling to prevent "Loading chunk failed" issues
(function () {
  function loadQualtricsScript(src) {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = src;
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      document.body.appendChild(script);
    });
  }
  function initQualtrics() {
    const qualtricsUrl =
      "https://zn2nindxpiwxmnnjn-fashionphile.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_2nINDxPiWxMNnjn&_v=" +
      Date.now();
    loadQualtricsScript(qualtricsUrl)
      .then(() => {
        console.log("✅ Qualtrics script loaded successfully");
      })
      .catch((err) => {
        console.warn("⚠️ Qualtrics script failed to load:", err);
        // Retry once if it's a "chunk failed" issue
        if (err && /Loading chunk/i.test(err.message) && !window._qualtricsRetry) {
          window._qualtricsRetry = true;
          setTimeout(() => location.reload(true), 1000);
        }
      });
  }
  if (document.readyState === "complete") {
    initQualtrics();
  } else {
    window.addEventListener("load", initQualtrics);
  }
})();

// Immediately stub affirm.ui.refresh to prevent race condition errors.
// Must run synchronously before Affirm's app tries to call it.
(function () {
  window.affirm = window.affirm || {};
  window.affirm.ui = window.affirm.ui || {};
  if (typeof window.affirm.ui.refresh !== "function") {
    window.affirm.ui.refresh = function () {
      console.warn("[Patch] affirm.ui.refresh fallback called");
      return Promise.resolve();
    };
  }
})();

// Patch to safely override navigator.permissions.query and prevent "Illegal invocation"
// errors caused by third-party scripts.
if (typeof navigator !== "undefined" && navigator.permissions && typeof navigator.permissions.query === "function") {
  const originalQuery = navigator.permissions.query;
  navigator.permissions.query = function (args) {
    try {
      return originalQuery.call(navigator.permissions, args);
    } catch (e) {
      return Promise.resolve({
        state: "denied",
        onchange: null,
      });
    }
  };
}

// Touchstart listener to prevent cross-origin frame access errors
window.addEventListener(
  "touchstart",
  function () {
    try {
      const test = window.parent.document;
    } catch (e) {
      console.warn("Blocked cross-origin frame access:", e);
    }
  },
  true,
);

// Wrap in DOMContentLoaded to ensure page is ready
document.addEventListener("DOMContentLoaded", function () {
  // Handle unhandled Promise rejections
  window.addEventListener("unhandledrejection", function (event) {
    const reason = event?.reason;
    const reasonString = typeof reason === "string" ? reason : reason?.message || "";

    // Shopify noise
    const ignorePatterns = [
      /Invocation canceled due to the underlying connection being closed/i,
      /InvalidAccessError/i,
      /NotReadableError/i,
    ];

    if (ignorePatterns.some((regex) => regex.test(reasonString))) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return false;
    }

    console.error("Unhandled promise rejection:", reason);
    event.preventDefault();
  });

  // Handle global JS errors
  window.onerror = function (message, source, lineno, colno, error) {
    console.error("Global JS error:", { message, source, lineno, colno, error });
  };

  // Safe SignalR placeholder for Shopify: avoids 404s and handles timeouts
  (() => {
    if (!location.pathname.includes("/collections/new-arrivals")) return;
    if (!window.signalR) return;
    const connection = {
      start: () => Promise.resolve(),
      onclose: () => {},
    };
    connection.start();
    window.addEventListener("unhandledrejection", (e) => {
      if (e.reason?.message?.includes("Server timeout")) {
        // silently handle SignalR timeouts
      }
    });
  })();
});
